import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface UserGroupFilledSvgProps extends Omit<SvgWrapperProps, 'children'> {}

export const UserGroupFilledSvg = ({
  ...svgProps
}: UserGroupFilledSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path d="M15.3828 9.50293C16.8273 10.2519 17.8145 11.7605 17.8145 13.5V14.5C17.8145 15.3284 17.1429 16 16.3145 16H12.9092C13.165 15.5584 13.3145 15.0471 13.3145 14.5V13.5C13.3145 12.5735 13.1033 11.697 12.7285 10.9141C13.7584 10.7237 14.6783 10.2205 15.3828 9.50293Z" />
    <path d="M11.8145 2C14.0236 2 15.8145 3.79086 15.8145 6C15.8145 8.08796 14.2145 9.80064 12.1738 9.98242C11.7662 9.42057 11.2645 8.93144 10.6904 8.54004C11.0871 7.78009 11.3145 6.91681 11.3145 6C11.3145 4.63912 10.8188 3.39486 10 2.43457C10.5446 2.15686 11.1612 2 11.8145 2Z" />
    <path d="M6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10Z" />
    <path d="M0 13.5C0 11.7604 0.987071 10.2514 2.43168 9.50244C3.33897 10.4267 4.60253 11 6 11C7.39746 11 8.66103 10.4267 9.56832 9.50245C11.0129 10.2514 12 11.7604 12 13.5V14.5C12 15.3284 11.3284 16 10.5 16H1.5C0.671573 16 0 15.3284 0 14.5V13.5Z" />
  </SvgWrapper>
);
